import { Routes } from '@angular/router';
import { AuthGuard } from './core/auth/guards/auth.guard';
import { RoleGuard } from './core/auth/guards/role.guard';
import { AdminGuard } from './core/guards/admin.guard';

export const routes: Routes = [
    {
        path: '',
        redirectTo: 'programs',
        pathMatch: 'full'
    },
    {
        path: 'dashboard',
        canActivate: [AuthGuard],
        loadChildren: () => import('./modules/dashboard/dashboard-routing.module').then(m => m.DashboardRoutingModule)
    },
    {
        path: 'onboarding',
        canActivate: [AuthGuard],
        loadChildren: () => import('./modules/onboarding/onboarding-routing.module').then(m => m.OnboardingRoutingModule)
    },
    {
        path: 'auth',
        loadChildren: () => import('./modules/auth/auth-routing.module').then(m => m.AuthRoutingModule)
    },
    {
        path: 'assessment',
        canActivate: [AuthGuard],
        loadChildren: () => import('./modules/assessment/assessment-routing.module').then(m => m.AssessmentRoutingModule)
    },
    {
        path: 'programs',
        canActivate: [AuthGuard],
        loadChildren: () => import('./modules/programs/programs-routing.module').then(m => m.ProgramsRoutingModule)
    },
    {
        path: 'adioscope',
        canActivate: [AuthGuard],
        loadChildren: () => import('./modules/adioscope/adioscope-routing.module').then(m => m.AdioscopeRoutingModule)
    },
    {
        path: 'vision-planner',
        canActivate: [AuthGuard],
        loadChildren: () => import('./modules/vision-planner/vision-planner-routing.module').then(m => m.VisionPlannerRoutingModule)
    },
    {
        path: 'pursuits',
        canActivate: [AuthGuard],
        loadComponent: () => import('./modules/hobbies/pages/pursuits-entry.component').then(m => m.PursuitsEntryComponent)
    },
    {
        path: 'coaches',
        canActivate: [AuthGuard],
        loadComponent: () => import('./modules/coaching/pages/my-coaches/my-coaches.component').then(m => m.MyCoachesComponent)
    },
    {
        path: 'life',
        canActivate: [AuthGuard],
        loadChildren: () => import('./modules/life/life.routes').then(m => m.LIFE_ROUTES)
    },
    {
        path: 'library',
        canActivate: [AuthGuard],
        loadChildren: () => import('./modules/library/library-routing.module').then(m => m.LibraryRoutingModule)
    },
    {
        path: 'store',
        canActivate: [AuthGuard],
        loadChildren: () => import('./modules/store/store-routing.module').then(m => m.StoreRoutingModule)
    },
    {
        path: 'subscription',
        canActivate: [AuthGuard],
        loadChildren: () => import('./modules/subscription/subscription-routing.module').then(m => m.SubscriptionRoutingModule)
    },
    {
        path: 'profile',
        canActivate: [AuthGuard],
        loadChildren: () => import('./modules/profile/profile.routes').then(m => m.ProfileRoutingModule)
    },
    {
        path: 'mind-fitness',
        canActivate: [AuthGuard],
        loadChildren: () => import('./modules/mind-fitness/mind-fitness.routes').then(m => m.MIND_FITNESS_ROUTES)
    },
    {
        path: 'unsubscribe',
        canActivate: [AuthGuard],
        loadComponent: () => import('./modules/profile/components/unsubscribe/unsubscribe.component').then(m => m.UnsubscribeComponent)
    },
    {
        path: 'admin',
        canActivate: [AuthGuard],
        loadChildren: () => import('./modules/admin/admin-routing.module').then(m => m.AdminRoutingModule)
    },
    {
        path: 'partner-console',
        canActivate: [AuthGuard],
        loadChildren: () => import('./modules/partner-console/partner-console.routing').then(m => m.PartnerConsoleRoutingModule)
    },
    {
        path: 'coach-console',
        canActivate: [AuthGuard],
        loadChildren: () => import('./modules/coach-console/coach-console.routing').then(m => m.CoachConsoleRoutingModule)
    },
    {
        path: 'partner',
        // canActivate: [AuthGuard],
        loadChildren: () => import('./modules/partner-profile/partner-profile-routing.module').then(m => m.PartnerProfileRoutingModule)
    },
    {
        path: 'contemplations/:slug',
        canActivate: [AuthGuard],
        loadComponent: () => import('./modules/contemplations/pages/contemplation-landing/contemplation-landing.component').then(m => m.ContemplationLandingComponent)
    },
    {
        path: 'support',
        canActivate: [AuthGuard],
        loadChildren: () => import('./modules/support-customer/support-customer.routes').then(m => m.SupportCustomerRoutingModule)
    },{
        path: 'manage',
        canActivate: [AuthGuard],
        children: [
            {
                path: 'stakeholders',
                loadChildren: () => import('./modules/admin/stakeholders/stakeholders-routing.module').then(m => m.StakeholdersRoutingModule)
            },
            {
                path: 'content',
                loadChildren: () => import('./modules/admin/manage-content/manage-content-routing.module').then(m => m.ManageContentRoutingModule)
            },
            {
                path: 'store',
                canActivate: [AdminGuard],
                loadChildren: () => import('./modules/manage-store/manage-store-routing.module').then(m => m.ManageStoreRoutingModule)
            },
            {
                path: 'notifications',
                canActivate: [AdminGuard],
                loadChildren: () => import('./modules/manage-notifications/manage-notifications-routing.module').then(m => m.ManageNotificationsRoutingModule)
            },
            {
                path: 'users',
                canActivate: [AdminGuard],
                loadChildren: () => import('./modules/admin/stakeholders/users/users-routing.module').then(m => m.UsersRoutingModule)
            },
            {
                path: 'conversations',
                canActivate: [AdminGuard],
                loadChildren: () => import('./modules/admin/conversations/conversations-routing.module').then(m => m.ConversationsRoutingModule)
            },
            {
                path: 'coaching',
                canActivate: [AdminGuard],
                loadComponent: () => import('./modules/coaching/pages/admin-coaching/admin-coaching.component').then(m => m.AdminCoachingComponent)
            },
            {
                path: 'recordings',
                canActivate: [AdminGuard],
                loadChildren: () => import('./modules/admin/recordings/recordings-routing.module').then(m => m.RecordingsRoutingModule)
            },
            {
                path: 'service-tokens',
                canActivate: [AdminGuard],
                loadChildren: () => import('./modules/admin/service-tokens/service-tokens-routing.module').then(m => m.ServiceTokensRoutingModule)
            },
            {
                path: 'support',
                canActivate: [AuthGuard],
                children: [
                    {
                        path: '',
                        redirectTo: '/',
                        pathMatch: 'full'
                    },
                    {
                        path: 'admin',
                        canActivate: [AdminGuard],
                        loadChildren: () => import('./modules/support-admin/pages/admin/admin.routes').then(m => m.SupportAdminRoutingModule)
                    },
                    {
                        path: 'agent',
                        loadChildren: () => import('./modules/support-admin/pages/agent/agent.routes').then(m => m.SupportAgentRoutingModule)
                    },
                    {
                        path: 'lead',
                        loadChildren: () => import('./modules/support-admin/pages/lead/lead.routes').then(m => m.SupportLeadRoutingModule)
                    }
                ]
            },
            {
                path: 'events',
                loadChildren: () => import('./modules/admin/manage-communication-events/manage-communication-events-routing.module')
                    .then(m => m.ManageCommunicationEventsRoutingModule)
            },
        ]
    }
];
